import ReportView, { type ReportColumn, type ReportOption } from '../../../components/reports/ReportView';

const STATUS_OPTIONS: ReportOption[] = [
  { value: 'draft', label: 'Draft' },
  { value: 'submitted', label: 'Submitted' },
  { value: 'pending_approval', label: 'Pending Approval' },
  { value: 'rejected', label: 'Rejected' },
  { value: 'approved', label: 'Approved' },
  { value: 'payment_generated', label: 'Payment Generated' },
  { value: 'disbursed', label: 'Disbursed' },
  { value: 'returned_to_suspense', label: 'Returned to Suspense' },
  { value: 'reversed', label: 'Reversed' },
];

const COLUMNS: ReportColumn[] = [
  { key: 'reference', label: 'Reference' },
  { key: 'member_name', label: 'Member' },
  { key: 'claim_type', label: 'Claim Type' },
  { key: 'status', label: 'Status' },
  { key: 'calculated_entitlement', label: 'Entitlement', align: 'right', type: 'money' },
  { key: 'approved_amount', label: 'Approved Amount', align: 'right', type: 'money' },
  { key: 'payment_method', label: 'Payment Method' },
  { key: 'disbursed_at', label: 'Disbursed On' },
];

export function ClaimsRegisterReport() {
  return (
    <ReportView
      title="Benefit Claims Register"
      description="Every benefit claim ever captured, at any stage — including disbursed, reversed, and rejected."
      endpoint="/reports/benefits/claims-register"
      columns={COLUMNS}
      filters={['status', 'dateRange']}
      statusOptions={STATUS_OPTIONS}
    />
  );
}
